export const KeyboardNavigationMixins = {
  data() {
    return {
      currentFocus: null,
    };
  },
  methods: {
    setFocus(option) {
      this.currentFocus = option;
    },
    unsetFocus() {
      this.currentFocus = null;
    },
    handleKeydownEvent(event) {
      if (this.currentFocus) {
        if (event.keyCode === 37) {
          this.prev();
        }
        if (event.keyCode === 39) {
          this.next();
        }
      }
    },
    next() {
      let nextElement = this.navigableOptions[this.navigableOptions.indexOf(this.currentFocus) + 1];
      if (typeof nextElement !== 'undefined') {
        this.$refs[nextElement][0] ? this.$refs[nextElement][0].focus() : this.$refs[nextElement].focus();
      }
    },
    prev() {
      let previousElement = this.navigableOptions[this.navigableOptions.indexOf(this.currentFocus) - 1];
      if (typeof previousElement !== 'undefined') {
        this.$refs[previousElement][0] ? this.$refs[previousElement][0].focus() : this.$refs[previousElement].focus();
      }
    },
  },
  created() {
    window.addEventListener('keydown', this.handleKeydownEvent);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydownEvent);
  },
};
